// SPDX-License-Identifier: AGPL-3.0-or-later

export type InlineTextCommand =
	| {
			type: 'me';
			content: string;
	  }
	| {
			type: 'bug';
			content: string;
	  }
	| {
			type: 'spoiler';
			content: string;
	  }
	| {
			type: 'tts';
			content: string;
	  };

const INLINE_TEXT_COMMANDS = [
	{prefix: '/me ', type: 'me', contentStart: 4},
	{prefix: '/bug ', type: 'bug', contentStart: 5},
	{prefix: '/spoiler ', type: 'spoiler', contentStart: 9},
	{prefix: '/tts ', type: 'tts', contentStart: 5},
] as const satisfies ReadonlyArray<{
	prefix: string;
	type: InlineTextCommand['type'];
	contentStart: number;
}>;

export function isInlineTextCommand(content: string): boolean {
	const trimmed = content.trim();
	return INLINE_TEXT_COMMANDS.some((command) => trimmed.startsWith(command.prefix));
}

/** Parses free-typed slash commands that only transform and send a channel message. */
export function parseInlineTextCommand(content: string): InlineTextCommand | null {
	const trimmed = content.trim();
	for (const command of INLINE_TEXT_COMMANDS) {
		if (!trimmed.startsWith(command.prefix)) {
			continue;
		}
		const body = trimmed.slice(command.contentStart).trim();
		if (body.length === 0) {
			return null;
		}
		return {type: command.type, content: body};
	}
	return null;
}
